import { render, staticRenderFns } from "./BtnMain.vue?vue&type=template&id=362a621c&scoped=true&"
import script from "./BtnMain.vue?vue&type=script&lang=js&"
export * from "./BtnMain.vue?vue&type=script&lang=js&"
import style0 from "./BtnMain.vue?vue&type=style&index=0&id=362a621c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a621c",
  null
  
)

export default component.exports